import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShip, faBoxOpen, faTruckMoving, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const ShipmentHeader = ({ shipments, onToggleView }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filter, setFilter] = useState({});

    const handleSearch = event => {
        setSearchTerm(event.target.value);
        // Add search logic here
    }

    const handleFilterChange = event => {
        setFilter({
            ...filter,
            [event.target.name]: event.target.value
        });
        // Add filter logic here
    }

    /*
    const shipmentCounts = {
        total: shipments.length,
        created: shipments.filter(s => s.status === 'Created').length,
        inTransit: shipments.filter(s => s.status === 'In Transit').length,
        delivered: shipments.filter(s => s.status === 'Delivered').length
    }
*/

    const shipmentCounts = {
        total: shipments.length,
        created: shipments.filter(s => s.jobStatus === 'WRK' || s.jobStatus === '' || s.jobStatus == null).length,
        inTransit: shipments.filter(s => s.jobStatus === 'WRK').length,
        delivered: shipments.filter(s => s.jobStatus === 'CMP').length
    };

    return (
        <>
            <div className="bg-white shadow rounded-lg p-4 mb-4">
                <div className="flex items-center justify-between mb-2">
                    <button
                        onClick={onToggleView}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded transition duration-300 focus:outline-none focus:shadow-outline">
                        Toggle View
                    </button>
                    <div className="relative w-1/4">
                        <input
                            type="text"
                            placeholder="Search shipments..."
                            value={searchTerm}
                            onChange={handleSearch}
                            className="border p-2 rounded w-full shadow-inner pl-10"
                        />
                        <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                            🔍
                        </span>
                    </div>
                </div>
                {/*
                <div className="flex items-center">
                    <div className="mr-2">
                        <label className="block text-sm font-medium text-gray-700">Filter By:</label>
                        <select
                            name="someField"
                            onChange={handleFilterChange}
                            className="border p-2 rounded shadow-inner mt-1">
                            {/* Options go here 
                            
                        </select>

                    </div>
                    
                </div>
            */}
            </div>
            <div className="bg-white shadow rounded-lg p-6 mb-4">

                <div className="grid grid-cols-4 divide-x divide-gray-200 text-center mt-4">
                    <div className="flex flex-col items-center justify-center py-2">
                        <FontAwesomeIcon icon={faShip} className="text-blue-600 text-2xl mb-1" />
                        <p className="text-sm text-gray-600">Total Shipments</p>
                        <p className="text-lg font-semibold text-gray-800">{shipmentCounts.total}</p>
                    </div>
                    <div className="flex flex-col items-center justify-center py-2">
                        <FontAwesomeIcon icon={faBoxOpen} className="text-blue-600 text-2xl mb-1" />
                        <p className="text-sm text-gray-600">Created</p>
                        <p className="text-lg font-semibold text-gray-800">{shipmentCounts.created}</p>
                    </div>
                    <div className="flex flex-col items-center justify-center py-2">
                        <FontAwesomeIcon icon={faTruckMoving} className="text-blue-600 text-2xl mb-1" />
                        <p className="text-sm text-gray-600">In Transit</p>
                        <p className="text-lg font-semibold text-gray-800">{shipmentCounts.inTransit}</p>
                    </div>
                    <div className="flex flex-col items-center justify-center py-2">
                        <FontAwesomeIcon icon={faCheckCircle} className="text-blue-600 text-2xl mb-1" />
                        <p className="text-sm text-gray-600">Delivered</p>
                        <p className="text-lg font-semibold text-gray-800">{shipmentCounts.delivered}</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ShipmentHeader;